import { LABEL_URL, FILE_URL, MODIFICATION_URL } from "../../../services/common-urls";
import { MHTTPCL, JSON_STRING, createHttpGetOptions } from "../../../services/http/http-client";
import { convertToFormData } from "../../../utility/fp";

export const TracksService = {
  getTracks: ({
    start = 0
  }) => MHTTPCL.post(LABEL_URL, {
    start,
    section: 'tracks',
    action: 'get_tracks'
  }),
  getScrollTracks: (start) => MHTTPCL.post(LABEL_URL, {
    section: 'tracks',
    action: 'get_tracks',
    start: start
  }),
  searchTracks: (search, artist, digital_right, isrc_check, start = 0) => MHTTPCL.post(LABEL_URL, {
    section: 'tracks',
    action: 'search_tracks',
    search,
    artist,
    digital_right,
    isrc_check,
    start,
  }),
  // searchScrollTracks: (search, artist, digital_right, isrc_check, start) => MHTTPCL.post(LABEL_URL, {
  //   section: 'tracks',
  //   action: 'search_tracks',
  //   search: search,
  //   artist: artist,
  //   digital_right: digital_right,
  //   isrc_check: isrc_check,
  //   start: start
  // }),
  advancedSearch: () => MHTTPCL.get(LABEL_URL, {
    section: 'tracks',
    action: 'advanced_search_modal',
    output: 'json',
  }),
  fetchAdvancedSearch: ({
    artist = "",
    title = "",
    version = "",
    track_type = "",
    digital_right = "",
    genres = "[]",
    isrc_error = 0,
    missing_main_product = 0,
    product_track_mismatch = 0,
    licence_account = "",
    main_label = "",
    any_label = "",
    royalty_account = "",
    no_contract = 0,
    playtime_missing = 0,
    composer_missing = 0,
    composer = "",
    writer_missing = 0,
    writer = "",
    publisher_missing = 0,
    publisher = "",
    producer_missing = 0,
    producer = "",
    arranger_missing = 0,
    arranger = "",
    royalty_period = "",
    invoice_project = "",
    metadata_field1 = "",
    metadata_value1 = "",
    metadata_field2 = "",
    metadata_value2 = "",
    metadata_field3 = "",
    metadata_value3 = "",
    income_start = "",
    income_end = "",
    track_grid = "",
    offset = 0,
  } = {}) => {
    const genreString = `[${genres?.length > 0 ? genres.split(',').map(e => `"${e}"`).join(",") : ''}]`;

    return MHTTPCL.post(LABEL_URL, {
      artist,
      title,
      version,
      track_type,
      digital_right,
      genres: genreString,
      isrc_error,
      missing_main_product,
      product_track_mismatch,
      licence_account,
      main_label,
      any_label,
      royalty_account,
      no_contract,
      playtime_missing,
      composer_missing,
      composer,
      writer_missing,
      writer,
      publisher_missing,
      publisher,
      producer_missing,
      producer,
      arranger_missing,
      arranger,
      royalty_period,
      invoice_project,
      metadata_field1,
      metadata_value1,
      metadata_field2,
      metadata_value2,
      metadata_field3,
      metadata_value3,
      income_start,
      income_end,
      track_grid,

      section: "tracks",
      action: "tracks_advanced_search",
      offset,
    })
  },
  exportAdvancedSearch: ({
    artist = "",
    title = "",
    version = "",
    track_type = "",
    digital_right = "",
    genres = "[]",
    isrc_error = 0,
    missing_main_product = 0,
    product_track_mismatch = 0,
    licence_account = "",
    main_label = "",
    any_label = "",
    royalty_account = "",
    no_contract = 0,
    playtime_missing = 0,
    composer_missing = 0,
    composer = "",
    writer_missing = 0,
    writer = "",
    publisher_missing = 0,
    publisher = "",
    producer_missing = 0,
    producer = "",
    arranger_missing = 0,
    arranger = "",
    royalty_period = "",
    invoice_project = "",
    metadata_field1 = "",
    metadata_value1 = "",
    metadata_field2 = "",
    metadata_value2 = "",
    metadata_field3 = "",
    metadata_value3 = "",
    income_start = "",
    income_end = "",
    track_grid = "",
  } = {}) => {

    const genreString = `[${genres?.length > 0 ? genres.split(',').map(e => `"${e}"`).join(",") : ''}]`;

    return MHTTPCL.postJSONasFormData(LABEL_URL, {
      artist,
      title,
      version,
      track_type,
      digital_right,
      genres: genreString,
      isrc_error,
      missing_main_product,
      product_track_mismatch,
      licence_account,
      main_label,
      any_label,
      royalty_account,
      no_contract,
      playtime_missing,
      composer_missing,
      composer,
      writer_missing,
      writer,
      publisher_missing,
      publisher,
      producer_missing,
      producer,
      arranger_missing,
      arranger,
      royalty_period,
      invoice_project,
      metadata_field1,
      metadata_value1,
      metadata_field2,
      metadata_value2,
      metadata_field3,
      metadata_value3,
      income_start,
      income_end,
      track_grid,

      section: "tracks",
      action: "filter_tracks_xls",

      offset: 0,
      row_count: 73709551615
    },
      createHttpGetOptions({
        responseType: 'blob'
      }))
  },

  newTracks: (artist, title, version) => MHTTPCL.post(LABEL_URL, {
    section: 'tracks',
    action: 'new_track',
    artist,
    title,
    version
  }),
  removeTrackList: (track_id) => MHTTPCL.post(LABEL_URL, {
    section: 'tracks',
    action: 'remove_track',
    track_id
  }),

  fetchTrackDetails: (track_id) => MHTTPCL.post(LABEL_URL, {
    section: 'tracks',
    action: 'track_overview',
    track_id
  }),
  fetchTrackDetailsReleaseProductLicensing: (track_id) => MHTTPCL.post(LABEL_URL, {
    section: 'tracks',
    action: 'track_release_product_licensing',
    track_id
  }),
  trackDetailsMetadata: (track_id) => MHTTPCL.post(LABEL_URL, {
    section: 'tracks',
    action: 'track_metadata',
    track_id,
    output: JSON_STRING
  }),
  showMetadata: (external_id) => MHTTPCL.post(LABEL_URL, {
    action: 'show_metadata',
    external_table: 'track',
    external_id,
    output: JSON_STRING
  }),
  fetchTrackDetailsSales: (track_id) => MHTTPCL.post(LABEL_URL, {
    section: 'tracks',
    action: 'track_sales',
    track_id
  }).then(res => {
    return {
      ...res,
      data: {
        salesData: res.data,
      }
    };
  }),

  relatedProducts: (track_id) => MHTTPCL.post(LABEL_URL, {
    section: 'tracks',
    action: 'related_products',
    track_id
  }),

  searchProducts: ({ str }) => MHTTPCL.post(LABEL_URL, {
    section: 'tracks',
    action: 'search_products',
    str
  }),

  setMainProduct: ({ track_id, product_id }) => MHTTPCL.post(LABEL_URL, {
    section: 'tracks',
    action: 'set_main_product',
    track_id,
    product_id
  }),

  newTrackCredit: () => MHTTPCL.post(LABEL_URL, {
    section: 'tracks',
    action: 'track_credit_form'
  }),

  detailsTrackInfo: ({ track_info_id }) => MHTTPCL.post(LABEL_URL, {
    section: 'tracks',
    action: 'edit_track_info',
    track_info_id
  }),

  submitTrackCredit: (track_id, track_info_id, type, name, percentage) => MHTTPCL.post(LABEL_URL, {
    section: 'tracks',
    action: 'submit_track_credit',
    track_id,
    track_info_id,
    type,
    name,
    percentage
  }),
  removeTrackCredit: (track_info_id) => MHTTPCL.post(LABEL_URL, {
    section: 'tracks',
    action: 'remove_track_credit',
    track_info_id
  }),

  submitTrackAdditional: (track_id, track_info_id, description, name, percentage) => MHTTPCL.post(LABEL_URL, {
    section: 'tracks',
    action: 'submit_track_additional',
    track_id,
    track_info_id,
    description,
    name,
    percentage
  }),

  unrelatedGenres: (track_id) => MHTTPCL.post(LABEL_URL, {
    section: 'tracks',
    action: 'unrelated_genres',
    track_id
  }),
  getRelatedProducts: (track_id) => MHTTPCL.post(LABEL_URL, {
    section: 'tracks',
    action: 'related_products',
    track_id:track_id,
    output: JSON_STRING
  }),
  setMainProduct: ({track_id,product_id}) => MHTTPCL.post(LABEL_URL, {
    section: 'tracks',
    action: 'set_main_product',
    track_id,
    product_id,
    output: JSON_STRING
  }),

  searchRelatedProducts: (str) => MHTTPCL.post(LABEL_URL, {
    section: 'tracks',
    action: 'search_products',
    str:str,
    output: JSON_STRING
  }),

  getDuplicateISRC: (track_id) => MHTTPCL.post(LABEL_URL, {
    section: 'tracks',
    action: 'duplicate_isrc',
    track_id:track_id,
    output: JSON_STRING
  }),

  searchUnrelatedGenres: ({ track_id, search }) => MHTTPCL.post(LABEL_URL, {
    section: 'tracks',
    action: 'search_unrelated_genres',
    track_id,
    search
  }),
  addTrackGenre: ({ track_id, genre_id }) => MHTTPCL.post(LABEL_URL, {
    section: 'tracks',
    action: 'add_track_genre',
    track_id,
    genre_id
  }),
  newTrackGenre: ({ track_id, genre_name }) => MHTTPCL.post(LABEL_URL, {
    section: 'tracks',
    action: 'track_new_genre',
    track_id,
    genre_name
  }),
  removeGenre: (genre_relation_id) => MHTTPCL.post(LABEL_URL, {
    section: 'tracks',
    action: 'remove_genre_relation',
    genre_relation_id
  }),

  searchUnrelatedDocsNew: ({ search_key, external_id, external_table }) => MHTTPCL.post(FILE_URL, {
    section: 'bookings',
    action: 'search_unrelated_docs_new',
    search_key,
    external_id,
    external_table
  }),

  addExternalIds: (track_id) => MHTTPCL.post(LABEL_URL, {
    section: 'tracks',
    action: 'add_external_id',
    track_id
  }),
  removeExternalIds: (relation_id) => MHTTPCL.post(LABEL_URL, {
    section: 'tracks',
    action: 'delete_l_relation',
    relation_id
  }),
  removeManualMatches: (relation_id) => MHTTPCL.post(LABEL_URL, {
    section: 'tracks',
    action: 'delete_l_relation',
    relation_id
  }),
  getLabelCopy: (track_id) => MHTTPCL.post(LABEL_URL, {
    section: 'tracks',
    action: 'get_labelcopy',
    track_id
  }),
  modify: ({ kVal, name, value }) =>
  MHTTPCL.post('/modify.pl', {
      kVal,
      name,
      value,
      table: 'l_tracks',
      output: "json",

  }),

  autoIsrc:(track_id)=>MHTTPCL.post(LABEL_URL,{
    section:	"tracks",
    action	: "auto_isrc",
    track_id:track_id
  })
}